import React from 'react';
import {
  Select,
} from 'antd';

const { Option } = Select;

class Search extends React.Component {
  // const Search = (props) => {

  constructor(props) {
    super(props);
    this.state = {
      selectVal: undefined,
    };
  }

  handleSelect = (value) => {
    console.log(`selected ${value}`);
    window.open(value.split('退款')[0]);
    this.setState({
      selectVal: undefined,
    });
  };

  render() {
    return (
      <Select
        showArrow={false}
        showSearch
        style={{ width: '120px', color: '#fff' }}
        placeholder="搜索"
        optionFilterProp="children"
        onSelect={this.handleSelect}
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        value={this.state.selectVal}
      >
        <Option value={`/index.html#/trading/trading-manage/trading-query`}>交易查询</Option>
        <Option value={`/index.html#/trading/settle-manage/settle-detail`}>结算明细</Option>
        <Option value="https://www.99bill.com/pay2bank/withdraw/withdraw/withdrawbankcardview.htm">提现</Option>
        <Option value={`/index.html#/trading/trading-manage/trading-query退款`}>单笔退款</Option>
        <Option value={`/index.html#/trading/trading-manage/refund-upload`}>批量退款</Option>
        <Option value={`/index.html#/trading/trading-manage/refund-applyQuery`}>退款审核</Option>
      </Select>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/views/MainLayout/HeaderBar/Search.jsx